module.exports = __webpack_public_path__ + "static/media/havilla_gift_content_image.4fb0512a.png";